export const KEY_PATTERN = /^[a-f0-9]{64}$/i;
export const PAIR_STORAGE = "emx_notecore_pair";
export const ROLE_STORAGE = "emx_notecore_role";
export const DESKTOP_DOWNLOAD = "https://emxtweaks.com/downloads/EMX-NoteCore-6.0.0-x64.exe";

export function createPairKey() {
  return Array.from(crypto.getRandomValues(new Uint8Array(32)), byte => byte.toString(16).padStart(2, "0")).join("");
}

export function extractPairKey(value) {
  const clean = value.trim();
  if (KEY_PATTERN.test(clean)) return clean.toLowerCase();
  try {
    const url = new URL(clean);
    const key = new URLSearchParams(url.hash.slice(1)).get("inbox") || url.searchParams.get("inbox") || "";
    return KEY_PATTERN.test(key) ? key.toLowerCase() : "";
  } catch { return ""; }
}

export function readPairing(url, storage) {
  const key = extractPairKey(url);
  if (key) {
    const role = new URLSearchParams(new URL(url).hash.slice(1)).get("role") === "pc" ? "pc" : "phone";
    return { key, role };
  }
  try {
    const saved = storage.getItem(PAIR_STORAGE) || "";
    return { key: KEY_PATTERN.test(saved) ? saved.toLowerCase() : "", role: storage.getItem(ROLE_STORAGE) === "pc" ? "pc" : "phone" };
  } catch { return { key: "", role: "phone" }; }
}

export function pairingUrl(origin, key, role = "phone") {
  const url = new URL("/", origin);
  url.hash = new URLSearchParams({ inbox: key, role }).toString();
  return url.href;
}

export function transferDirections(role) {
  return role === "pc" ? { send: "to_phone", receive: "to_pc" } : { send: "to_pc", receive: "to_phone" };
}
